/** Inclusive Max-results caps — keep in sync with pipeline defaults / AdditionalSearchOption. */
export const SOURCE_MAX_CAPS = {
  apollo: 2000,
  coresignal: 500,
  gmaps: 500,
  linkedin: 200,
  findall: 1000,
} as const;

/** Parse a max-results string to a positive int, falling back to `fallback` (the blank-field
 * default) when empty/invalid. Used by the Run Summary's Max companies / Est. credits math. */
export function parseMaxResults(raw: string | undefined, fallback = 50): number {
  const n = Number.parseInt(raw ?? '', 10);
  return Number.isFinite(n) && n > 0 ? n : fallback;
}

/** Clamp a typed max-results string to 1..cap. Empty stays empty so the user can clear and retype. */
export function clampMaxResults(raw: string, cap?: number): string {
  if (raw.trim() === '') return '';
  const n = Number.parseInt(raw, 10);
  if (!Number.isFinite(n)) return '';
  const minClamped = Math.max(1, n);
  return cap == null ? String(minClamped) : String(Math.min(minClamped, cap));
}
